module.exports = __webpack_public_path__ + "static/2-49babf8c7119910227f62ba7fefad1ee.jpeg";